<quill-editor
    [(ngModel)]="editorContent"
    [modules]="quillConfig"
    [sanitize]="true"
    class="quill-editor"
    placeholder = "Bearbeiten Sie hier den Inhalt..."
    [theme]="'snow'">
</quill-editor>
<button mat-button (click)="saveEditorContent()">Speichern</button>